<!-- ================管理端-用户管理====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">用户列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleImportUser">批量导入用户</div>
            <div class="admin-btn-item" @click="handleRegUser">添加用户</div>
            <div class="admin-btn-item right-start" @click="downloadTemplate">下载导入模板</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">所属机构:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.orgId" placeholder="请选择">
                        <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                   :value="item.orgId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.trueName" placeholder="请输入姓名或手机号" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column label="用户账号" align="center" width="120" prop="username"></el-table-column>
                <el-table-column width="140" align="center" label="姓名" prop="trueName">
                    <template #default="scope">
                        <div :title="scope.row.trueName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.trueName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="用户角色" prop="userRole">
                    <template #default="scope">
                        <el-tag v-if="scope.row.userRole === 1" type="success">超级管理员</el-tag>
                        <el-tag v-if="scope.row.userRole === 2" type="success">平台管理员</el-tag>
                        <el-tag v-if="scope.row.userRole === 3" type="success">一级代理</el-tag>
                        <el-tag v-if="scope.row.userRole === 4" type="success">二级代理</el-tag>
                        <el-tag v-if="scope.row.userRole === 5" type="success">机构管理员</el-tag>
                        <el-tag v-if="scope.row.userRole === 6" type="success">平台用户</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="60" align="center" label="性别" prop="gender">
                    <template #default="scope">
                        <el-tag v-if="scope.row.gender === 0" type="success">男</el-tag>
                        <el-tag v-if="scope.row.gender === 1" type="danger">女</el-tag>
                    </template>
                </el-table-column>
                <el-table-column  label="所属机构" align="center" prop="orgName" />
                <el-table-column width="70" align="center" label="学段" prop="periodName" />
                <el-table-column width="140" align="center" label="学科" prop="subjectName" />
                <el-table-column
                  fixed="right" :width="100" label="操作"
                  class-name="small-padding fixed-width" align="center">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click" :width="120" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default" >操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item" v-if="scope.row.adminRole !== 1">
                                        <el-popconfirm
                                          confirm-button-text="是"
                                          cancel-button-text="否"
                                          icon-color="#626AEF"
                                          title="确定删除该用户"
                                          @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text>删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                    <div class="text-item">
                                        <el-text @click="handHonor(scope.row)">荣誉</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-text @click="handleLook(scope.row)">证书</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.adminRole === 3">
                                        <el-text @click="handleAdminAdd(scope.row)">设置平台管理</el-text>
                                    </div>

                                    <div class="text-item" v-if="scope.row.adminRole === 2">
                                        <el-text @click="handleAdminCancel(scope.row)">撤销平台管理</el-text>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
    </div>

    <el-dialog :title="'用户导入'" v-model="isImportUserShow" width="300px">
        <el-form ref="reportForm" label-width="60px">
            <el-row style="width: 100%;">
                <el-col :span="24">
                    <el-form-item label="机构">
                        <el-select  v-model="orgId" placeholder="请选择组织机构">
                            <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                       :value="item.orgId" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center disnone" style="align-items: unset;">
                <el-upload v-if="orgId" v-model:file-list="filesList" class="upload-demo"
                           :action="serviceUrl+'/businessservice/user/batchImport'"
                           :on-change="handleChange"
                           :headers="{ token }" :on-remove="handleRemove" :data="{ orgId: this.orgId }"
                           accept=".xlsx"
                           :before-upload="beforeUpload">
                    <el-button type="primary">上 传</el-button>
                </el-upload>
                <el-button class="ml15" @click="isImportUserShow = false">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog title="添加用户" v-model="isShowUserDialog" width="500px">
        <el-form ref="userForm" :model="userForm" :rules="userFormRules" label-width="60px">
            <el-row>
                <el-col :span="14">
                    <el-form-item label="机构" prop="orgId">
                        <el-select v-model="userForm.orgId" placeholder="请选择组织机构">
                            <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                       :value="item.orgId" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="手机" prop="username">
                        <el-input v-model="userForm.username" placeholder="请输入手机号码"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名" prop="trueName">
                        <el-input v-model="userForm.trueName" placeholder="请输入姓名"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="性别" prop="gender">
                        <el-radio-group v-model="userForm.gender">
                            <el-radio :label="0">男</el-radio>
                            <el-radio :label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="学段" prop="periodKey">
                        <el-select @change="changePeriod" v-model="userForm.periodKey" placeholder="请选择学段">
                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="年级" prop="gradeKey">
                        <el-select @change="changeGrade" v-model="userForm.gradeKey" placeholder="请选择年级">
                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="学科" prop="subjectKey">
                        <el-select style="width: 100%;" v-model="userForm.subjectKey" placeholder="请选择学科">
                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                       :value="item.dictKey" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center">
                <el-button type="primary" @click="submitUserForm">确 定</el-button>
                <el-button @click="isShowUserDialog = !isShowUserDialog">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog draggable :title="'荣誉管理'" v-model="honorShow" width="500px">
        <el-row>
            <el-col :span="8" v-for="item in 9" :key="item">
                <div style="width: 70%;margin: 0 auto;padding: 10px;">
                    <img class="cursor" @click="changeLight(item)" style="width: 100%;"
                         :src="require(`../../../assets/rycj/${honorList.indexOf(item.toString()) == -1 ? 'ryh' : 'ry'}-${item}.png`)"
                         alt="">
                </div>
            </el-col>
        </el-row>
    </el-dialog>

    <el-dialog draggable :title="'证书'" v-model="fileShow" width="80%">
        <div class="fl-warp" style="display: flex;flex-wrap: wrap;">
            <div v-for="(item, index) in showFileList" :key="item.certId" class="csbbb">
                <el-popconfirm confirm-button-text="是" cancel-button-text="否" icon-color="#626AEF"
                               title="确定删除该证书" @confirm="delBookId(item.certId, index)">
                    <template #reference>
                        <el-icon :size="20" class="eicon" style="cursor: pointer;z-index: 99;color: red;">
                            <Delete />
                        </el-icon>
                    </template>
                </el-popconfirm>
                <el-image fit="cover" :initial-index="index" :preview-src-list="showUrlList"
                          style="width: 180px;height:130px;margin-bottom: 10px;object-fit: cover;" :src="item.certUrl"
                          alt="" class="image" />
            </div>
            <div class="csbbb">
                <el-upload v-model:file-list="filesList" class="avatar-uploader"
                           :action="serviceUrl+'/businessservice/cert/upload'" :show-file-list="false"
                           :on-change="handleSCChange" :before-upload="beforeAvatarUpload" :headers="{ token }"
                           :data="{ userId: selectObj.userId }">
                    <el-icon style="width: 180px;height:130px;" class="avatar-uploader-icon">
                        <Plus />
                    </el-icon>
                </el-upload>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {pageUser,userDelete,adminAdd,adminCancel,registerUser,userLightHonorOrCancel} from "@/api/admin/user";
import {userCerts,certDelete} from "@/api/admin/certs";
import {queryUserManagerOrg} from "@/api/admin/org"
import {queryDict} from "@/api/admin/dict";
import {timestampDate, timestampToTime} from "@/utils/date";
import {download} from "@/utils/download"
import {serviceUrl} from "@/utils/global";

export default {
    components: {},
    name: "userIndex",
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            timestampToTime,
            timestampDate,
            loading: false,
            /*分页查询一级代理商*/
            queryParams:{
                orgId: '',
                trueName: '',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            orgList:[],
            // 用户导入
            orgId:'',
            filesList:[],
            isImportUserShow:false,
            // 添加用户
            isShowUserDialog:false,
            periodList:[],
            gradeList:[],
            subjectList:[],
            userForm:{
                orgId:'',
                username:'',
                trueName:'',
                gender:0,
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
            },
            userFormRules: {
                orgId: [{ required: true, message: "请选择组织机构", trigger: "change" },],
                username: [{ required: true, message: "请输入手机号码", trigger: "blur" },],
                trueName: [{ required: true, message: "请输入姓名", trigger: "blur" },],
                gender: [{ required: true, message: "请选择性别", trigger: "change" },],
            },
            // 荣誉
            honorShow:false,
            honorList:[],
            selectObj:{},
            // 证书
            fileShow:false,
            showFileList:[],
            showUrlList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageList();
        this.queryUserManagerOrg();
        this.getQueryDict();
    },
    mounted() {},
    methods: {
        /*===========数据查询============*/
        handleQuery(){
            this.pageList(null);
        },
        queryUserManagerOrg(){
            queryUserManagerOrg().then(res => {
                if (res.data.code === 1) {
                    this.orgList = res.data.data;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageUser(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        downloadTemplate() {
            download('https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/excel/%E5%8D%9A%E9%9B%85%E7%BE%8E%E8%82%B2%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', '用户导入模板')
        },
        /*===========用户导入============*/
        handleImportUser(){
            this.orgId = "";
            this.isImportUserShow = true;
        },
        beforeUpload(rawFile) {
            if (!(rawFile.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                this.$message.error('文件格式有误')
                return false
            } else if (rawFile.size / 1024 / 1024 > 20) {
                this.$message.error('文件大小不能超过20M')
                return false
            }
            return true
        },
        handleRemove(file, uploadFiles) {
        },
        handleChange(e, type) {
            if (e.response) {
                if (e.response.code === 1) {
                    this.$message.success('用户导入成功')
                    this.orgId = '';
                    this.isImportUserShow = false;
                    this.pageList();
                } else {
                    if (e.response.msg) {
                        this.$message.error(e.response.msg)
                    } else {
                        this.$message.error('用户导入失败')
                    }
                }
            }
            if (e.status === 'fail') {
                this.$message.error('用户导入失败')
            }
        },
        /*===========添加用户============*/
        handleRegUser(){
            this.isShowUserDialog = true;
        },
        getQueryDict(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
        },
        changePeriod() {
            this.userForm.gradeKey = '';
            this.userForm.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.userForm.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.userForm.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.userForm.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.userForm.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        submitUserForm(){
            this.$refs["userForm"].validate(valid => {
                if (valid) {
                    registerUser(this.userForm).then(res => {
                        if (res.data.code === 1) {
                            this.pageList();
                            this.$message.success("操作成功")
                            this.isShowUserDialog = false;
                        }else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            })
        },
        /*===========管理员============*/
        handleAdminAdd(row) {
            adminAdd({ userId: row.userId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success('操作成功')
                    this.pageList()
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        handleAdminCancel(row) {
            adminCancel({ userId: row.userId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success('操作成功')
                    this.pageList()
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        handleDelete(row) {
            userDelete({ userId: row.userId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList()
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        /*===========荣誉============*/
        handHonor(row) {
            this.honorList = [];
            this.selectObj = row;
            if (row.honor) {
                this.honorList = row.honor.split(',')
                if (this.honorList[this.honorList.length - 1] === '') {
                    this.honorList.splice(this.honorList.length - 1, 1)
                }
            }
            this.honorShow = true;
        },
        changeLight(index) {
            var len = this.honorList.indexOf(index.toString())
            this.$confirm('确认' + (len == -1 && len != 0 ? '点亮' : '取消') + '该荣誉?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userLightHonorOrCancel({ honorNo: index, userId: this.selectObj.userId }).then(res => {
                    if (res.data.code === 1) {
                        this.$message.success('操作成功')
                        if (len != -1) {
                            this.honorList.splice(len, 1)
                        } else {
                            this.honorList.push(index.toString())
                        }
                        this.selectObj.honor = this.honorList.toString()
                    } else {
                        this.$message.error('操作失败')
                    }
                })
            }).catch(() => {
            });
        },
        /*===========证书============*/
        handleLook(row) {
            this.selectObj = row;
            this.showFileList = [];
            this.showUrlList = [];
            userCerts({ userId: row.userId }).then(reson => {
                this.showFileList = reson.data.data;
                reson.data.data.forEach(e => {
                    this.showUrlList.push(e.certUrl)
                })
            })
            this.fileShow = true;
        },
        delBookId(certId, index) {
            certDelete({ certId }).then(res => {
                if (res.data.code === 1) {
                    this.showFileList.splice(index, 1);
                    this.showUrlList.splice(index, 1);
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('操作失败');
                }
            })
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleSCChange(e, type) {
            if (e.response) {
                if (e.response.code === 1) {
                    this.$message.success('上传成功')
                    this.showUrlList = [];
                    userCerts({ userId: this.selectObj.userId }).then(reson => {
                        this.showFileList = reson.data.data;
                        reson.data.data.forEach(e => {
                            this.showUrlList.push(e.certUrl)
                        })
                    })
                    this.pageList()
                } else {
                    if (e.response.msg) {
                        this.$message.error(e.response.msg)
                    } else {
                        this.$message.error('上传失败')
                    }
                }
            }
            if (e.status === 'fail') {
                this.$message.error('上传失败')
            }
        },
    },
}
</script>
<style scoped>
.admin-select1{
    width: 90px;
}
.admin-select1 /deep/ .el-select__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    position: relative;
}

.csbbb .eicon {
    display: none;
    position: absolute;
    right: 20px;
    top: 5px;
    background-color: #e4e7ed;
}

.csbbb:hover .eicon {
    display: block;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader /deep/ .el-upload:hover {
    border-color: var(--el-color-primary);
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

</style>
